export const environment = {
    production: true,
    GOOGLE_ANALYTICS_KEY: ''
};
